/**
 * Market intelligence fetch utilities.
 *
 * Async functions that call the /market-intelligence proxy routes.
 * Auth is handled automatically by the fetch interceptor (Bearer token injected).
 * Each function accepts an apiBaseUrl and a params object; omits null/undefined values.
 */

function buildUrl(base, path, params = {}) {
  const url = new URL(`${base}${path}`);
  Object.entries(params).forEach(([k, v]) => {
    if (v !== null && v !== undefined) url.searchParams.set(k, v);
  });
  return url.toString();
}

async function get(apiBaseUrl, path, params = {}) {
  const url = buildUrl(apiBaseUrl, `/market-intelligence${path}`, params);
  const response = await fetch(url);
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.detail || `HTTP ${response.status}`);
  }
  return response.json();
}

export async function fetchTrending(apiBaseUrl, params = {}) {
  return get(apiBaseUrl, '/trending', params);
}

export async function fetchArticles(apiBaseUrl, params = {}) {
  return get(apiBaseUrl, '/articles', params);
}

export async function fetchSentiment(apiBaseUrl, params = {}) {
  return get(apiBaseUrl, '/sentiment', params);
}

export async function fetchTokenSentimentDetail(apiBaseUrl, tokenSymbol, params = {}) {
  return get(apiBaseUrl, `/sentiment/${encodeURIComponent(tokenSymbol)}`, params);
}

export async function fetchWhaleFlow(apiBaseUrl, params = {}) {
  return get(apiBaseUrl, '/whale-flow', params);
}

export async function fetchWhaleActivity(apiBaseUrl, params = {}) {
  return get(apiBaseUrl, '/whale-activity', params);
}

export async function fetchTokenIntelligence(apiBaseUrl, params = {}) {
  return get(apiBaseUrl, '/token-intelligence', params);
}
